import axiosInstance from "./axiosInstance";

export const checkAuthAdminApi = async () => {
  const res = await axiosInstance.get(
    "/api/v4/auth/dashbaord/check-auth-admin"
  );
  return res.data; 
};


export  const Logout = async()=>{
  const res = await axiosInstance.post(
    "/api/v4/auth/dashboard/adm-logout"
  );
  return res.data;
}


export const getNewAdminAccessTokenApi = async()=>{
  const res = await axiosInstance.get("/api/v4/auth/dashboard/getnewaccess-token");
  return res.data;

}


export const getAppPolicy = async ()=>{
  const res = await axiosInstance.get("/api/settings/auth/app/settings/get-company-about");
  return res.data;
}


export const updateAppPolicy = async (id, payload) => {
  const res = await axiosInstance.put(
    `/api/settings/auth/app/settings/update-company-about/${id}`,
    payload
  );
  return res.data;
};
